export default "__VITE_ASSET__DAKooek6__"